<template>
  <div id="vue-root" aria-hidden="true"></div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

export default {
  name: 'App'
}
</script>

<style>
html, body {
  overflow-x: hidden !important;
  position: relative;
}
</style>
